import React from "react";
import Button from "@mui/material/Button";
function CustomButon({ variant, className, sx, children, type, onClick }) {
  return (
    <>
      <Button
        variant={variant}
        type={type}
        onClick={onClick}
        className={className}
        sx={{
          ...sx,
          textTransform: "capitalize",
        }}
      >
        {children}
      </Button>
    </>
  );
}

export default CustomButon;
